/* eslint-disable  import/order */
/* eslint-disable  prefer-destructuring */
/* eslint-disable  react/jsx-no-undef, no-debugger */

import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as yup from 'yup';
import dayjs from 'dayjs';

import { ColDiv, Container, RowDiv, Span, Text, SubWrap } from 'styles';
import { Input, SubTitle, Textarea, FileInput, Checkbox, Button, Icon } from 'components';
import {Alert} from "components/modal/Alert";
import * as S from './InquiryStyle';
import InquiryForm from 'components/pages/community/inquiry/InquiryForm';
import { useNavigate } from 'react-router-dom';
import {ScrollToError} from "../../../components/common/formik/ScrollToError";
import { getByteSize } from 'utils';

function InquiryView({ list, onChange, values, agree, agreeCheck, submit, inquiryList = [], inquiryTotal = 0 }) {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [alert, setAlert] = useState(false);
  const [isPrivate, setIsPrivate] = useState(false);

  const privateCheck = (val, name, checked) => {
    setIsPrivate(!!checked);
  };

  const stats = list.stats || {};
  const maskName = (name) => {
    if (!name) return '익명';
    const n = String(name).trim();
    if (n.length <= 1) return n;
    if (n.length === 2) return `${n[0]}*`;
    return `${n[0]}${'*'.repeat(n.length - 2)}${n[n.length - 1]}`;
  };

  const onInquiryClick = (item) => {
    navigate('/community/inquiry/view', { state: { contentNo: item.contentNo } });
  };

  const schema = yup.object().shape({
    regUserName: yup.string()
      .required(list.messages.required)
      .test('maxByte', '최대 입력값은 100 바이트(byte) 입니다.', val => getByteSize(val) <= 100),
    regUserPhone: yup.string()
      .required(list.messages.required)
      .matches(/^\d+$/ , list.messages.invalidPhone)
      .test('maxByte', '최대 입력값은 20 바이트(byte) 입니다.', val => getByteSize(val) <= 20),
    regUserEmail: yup.string()
      .required(list.messages.required)
      .email(list.messages.invalidEmail)
      .test('maxByte', '최대 입력값은 100 바이트(byte) 입니다.', val => getByteSize(val) <= 100),
    title: yup.string()
      .required(list.messages.required)
      .test('maxByte', '최대 입력값은 255 바이트(byte) 입니다.', val => getByteSize(val) <= 255),
    regPassword: yup.string().concat(
      isPrivate
        ? yup.string()
            .required(list.messages.required)
            .test('minByte', '비밀번호는 4자 이상 입력해주세요.', val => getByteSize(val) >= 4)
        : null
    ),
    passwordCheck: yup.string().concat(
      isPrivate
        ? yup.string()
            .required(list.messages.required)
            .oneOf([yup.ref('regPassword'), null], '비밀번호가 일치하지 않습니다.')
        : null
    )
  });

  const handleOnSubmit = async (values) => {
    if(!agree){
      setAlert({
        content: list.messages.requiredPolicy,
        confirm: {
          onClick: () => {
            setAlert(null);
          }
        }
      });
      return ;
    }
    if(!saving){
      setSaving(true);
      const form = document.getElementById('form-inquiry');
      const data = new FormData(form);
      if (!isPrivate) {
        data.delete('regPassword');
        data.delete('passwordCheck');
      }
      const res = await fetch(
        '/api/public/board/saveContent.json',
        {
          method: 'POST',
          body: data,
        }
      );
      setSaving(false);
      if (res.ok) {
        // GA4: 견적문의 접수 완료 (주요 이벤트)
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'generate_lead', { form_id: 'form-inquiry' });
        }
        setAlert({
          content: list.messages.saveDone,
          confirm: {
            onClick: () => {
              setAlert(null);
              navigate(0);
            }
          }
        });

      }
    }


  };

  return (
    <>
      {alert && <Alert {...alert} />}
      <Formik
        initialValues={{
          regUserName: '',
          regUserPhone: '',
          regUserEmail: '',
          title: '',
          content: '',
          regPassword: '',
          passwordCheck: '',
          uploadFile: null
        }}
        validationSchema={schema}
        onSubmit={handleOnSubmit}
      >
        {formik => (
          <ColDiv $width="100%" $gap={24}>
            <SubWrap $type="first">
              <Container $gap={48}>
                <SubTitle title={list.subject} desc={list.subjectDesc} />
                <S.ContentBox>
                  <InquiryForm formik={formik} list={list}
                               agree={agree}
                               agreeCheck={agreeCheck}
                               isPrivate={isPrivate}
                               privateCheck={privateCheck}/>
                </S.ContentBox>
              </Container>
              <RowDiv $gap={8} $padding="0 24px">
                <Checkbox checked={agree} onChange={agreeCheck}>
                  {list.agree}
                </Checkbox>
                <Text $type="b7" $fontWeight={500} $color="secondary300">
                  {list.agreeView}
                </Text>
              </RowDiv>
              <S.ButtonBox>
                <Button label={list.submitBtn} btnType="xLarge" btnStyle="fill"
                        onClick={(e) =>{
                          formik.submitForm();
                        }} />
              </S.ButtonBox>
            </SubWrap>
            <ScrollToError/>
          </ColDiv>
        )}

      </Formik>

      <SubWrap>
        <Container $gap={24}>
          <S.StatBox>
            <Text $type="b6" $mType="b7" $fontWeight={500} $color="secondary300">
              {stats.label}
            </Text>
            <S.StatCount>
              {Number(inquiryTotal).toLocaleString()}
              <span className="unit">{stats.unit}</span>
            </S.StatCount>
            <Text $type="b6" $mType="b7" $fontWeight={500} $color="secondary300">
              {stats.desc}
            </Text>
          </S.StatBox>

          <ColDiv $gap={16}>
            <Text $type="h5" $mType="h6" $fontWeight={700}>
              {stats.recentTitle}
            </Text>
            {inquiryList && inquiryList.length > 0 ? (
              <S.RecentList>
                {inquiryList.map((item) => (
                  <S.RecentItem key={`inquiry_${item.contentNo}`} onClick={() => onInquiryClick(item)}>
                    <div className="title">
                      <Text $type="b6" $mType="b7" $fontWeight={500} $maxLine={1}>
                        {item.title}
                      </Text>
                      {item.useSecret && <Icon name="lock" $width={18} $height={18} $padding="0" />}
                    </div>
                    <div className="meta">
                      <Text $type="b7" $mType="b8" $fontWeight={500} $color="secondary300">
                        {maskName(item.regUserName)}
                      </Text>
                      <Text $type="b7" $mType="b8" $color="secondary300">
                        {item.regDate ? dayjs(item.regDate).format('YYYY.MM.DD') : ''}
                      </Text>
                    </div>
                  </S.RecentItem>
                ))}
              </S.RecentList>
            ) : (
              <Text $type="b6" $color="secondary300">{stats.empty}</Text>
            )}
          </ColDiv>
        </Container>
      </SubWrap>
    </>
  );
};

export default InquiryView;

